import { RootState, useAppSelector } from '..';

export const selectMachineDetails = (state: RootState) => state.machineDetails;
export const useMachineDetails = () => useAppSelector(selectMachineDetails);
